/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormationGridDto } from './FcbFormationGridDto';
import {
    FcbFormationGridDtoFromJSON,
    FcbFormationGridDtoFromJSONTyped,
    FcbFormationGridDtoToJSON,
} from './FcbFormationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormationGridDtoPaginatedResults
 */
export interface FcbFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormationGridDto>}
     * @memberof FcbFormationGridDtoPaginatedResults
     */
    results?: Array<FcbFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormationGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormationGridDtoPaginatedResultsFromJSON(json: any): FcbFormationGridDtoPaginatedResults {
    return FcbFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormationGridDtoPaginatedResultsToJSON(value?: FcbFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

